import script from "./PlantTree.vue?vue&type=script&setup=true&lang=js"
export * from "./PlantTree.vue?vue&type=script&setup=true&lang=js"

import "./PlantTree.vue?vue&type=style&index=0&id=31577d94&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31577d94"]])

export default __exports__